/**
     * Reviews Slick
     */
 $('#reviewsList').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    speed: 700,
    adaptiveHeight: true,
    centerMode: false
});
